import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { isLoading } from "features/probe/probeSlice";
import { hubData } from "features/hub/hubSlice";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Loading from "../../components/Loading";
import ProbeOverView from "../../components/ProbeOverView";
import useTimeout from "hooks/useTimeout";

const Logs = () => {
  const dispatch = useDispatch();

  /**
   * Selectors
   */
  const loading = useSelector(isLoading);

  /**
   * States
   */
  const [probes, setProbes] = useState<Array<common.Probe>>();

  /**
   * Life cycles
   */
  // Fetch the log data
  //   useEffect(() => {
  //     if (hub?.probeIds) {
  //       dispatch(getProbeSummaryThunk(hub.probeIds));
  //     }
  //   }, [hub?.id]);

  return (
    <Grid container spacing={3}>
      I want some logs
    </Grid>
  );
};

export default Logs;
